import ExercisesOfTheDayPage from './ExercisesOfTheDayPage';

export default ExercisesOfTheDayPage;
